export class DataCatalogPipelineSource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "alias",
            "baseName": "alias",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogName",
            "baseName": "catalogName",
            "type": "DataCatalogPipelineAddressPart",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<DataCatalogPipelineAddressPart>",
            "format": ""
        },
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "DataCatalogPipelineAddressPart",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineSource.attributeTypeMap;
    }
    constructor() {
    }
}
